import { Box, Divider, useMediaQuery, useTheme } from '@mui/material';
import { IImpactConsumerScanItem, IMedia, IScan, IUnSdg } from 'src/types';
import { ImageCarousel, LatestBlockchainTransactions } from 'src/components'
import { UnSdgList } from './un-sdg-list.component'
import { LikesCounter } from './likes-counter.component'
import {
  UpperWrapper,
  Item,
  ItemText,
  ItemTitle,
  BottomWrapper,
  CarouselWrapper,
  ItemTextWrapper,
} from './impact-cards-ver.styled'
import { MediaList } from '../media-list'
import { AvatarImg } from '../step-info/step-company.styled'
import { BlockchainVerifiedBanner } from '../blockchain-verified-banner'
import { AIGeneratedBanner } from '../ai-generated-banner'
import { AIVerifiedBanner } from '../ai-verified-banner'
import { WorldHeartIcon } from 'src/assets/icons/v2/WorldHeartIcon'
import { QuillHtmlParser } from '../quill-html-parser'

interface IProps {
  title: string | number
  subtitle: string
  image: string
  description: string
  media: IMedia[]
  mainMedia: IMedia[]
  unSdg: IUnSdg[]
  likes: number
  impactId: string
  liked: boolean
  quantityName: string
  showUnSdg: boolean
  scans: IScan[]
  primaryColor: string
  walletAddress: string
  showWalletAddress: boolean
  showBcInfo: boolean
  showLatestBcOnImpacts: boolean
  accountImage: string
  aiGenerated: boolean
  aiVerifiedCount: number
  aiVerifiedInfo: IImpactConsumerScanItem[]
}

export const ImpactCard = (props: IProps) => {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'))

  const isEmpty = !props.image || props.image.trim().length === 0
  const isUiAvatar = props.image?.includes('ui-avatars.com/api')
  const showFallback = isEmpty || isUiAvatar
  return (
    <Item id={props.impactId}>
      <UpperWrapper id="impact-card-component__components-impacts-cards-ver__upperwrapper__l56">
        <Box
          id="impact-card-component__components-impacts-cards-ver__box__l57"
          sx={{ position: 'relative', pt: props.aiGenerated ? '22px' : 0 }}
        >
          {props.aiGenerated && <AIGeneratedBanner />}
          {showFallback ? (
            <Box
              id="impact-card-component__components-impacts-cards-ver__box__l60"
              sx={{
                width: '100px',
                height: '100px',
                borderRadius: props.aiGenerated ? '0px 0px 10px 10px' : '10px',
                backgroundColor: theme.palette.background.paper,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
              }}
              aria-label="fallback impact icon"
            >
              <WorldHeartIcon size={80} color={'#666'} />
            </Box>
          ) : (
            <AvatarImg
              id="impact-card-component__components-impacts-cards-ver__avatarimg__l76"
              borderRadius={props.aiGenerated ? '0px 0px 10px 10px' : '10px'}
              width={'100px'}
              src={props.image}
              alt={props.subtitle || 'impact'}
            />
          )}
        </Box>
        <div id="impact-card-component__components-impacts-cards-ver__div__l84">
          <ItemTextWrapper id="impact-card-component__components-impacts-cards-ver__itemtextwrapper__l85">
            <ItemTitle
              id="impact-card-component__components-impacts-cards-ver__itemtitle__l86"
              variant="h2"
            >
              {props.title}
            </ItemTitle>
            <ItemText
              id="impact-card-component__components-impacts-cards-ver__itemtext__l87"
              variant="h4"
            >
              {props.quantityName}
            </ItemText>
          </ItemTextWrapper>
          <ItemText
            id="impact-card-component__components-impacts-cards-ver__itemtext__l89"
            variant="subtitle2"
          >
            {props.subtitle}
          </ItemText>
        </div>
        {!isTablet && props.showUnSdg && <UnSdgList unSdg={props.unSdg} />}
      </UpperWrapper>
      {props.mainMedia.length ? (
        <CarouselWrapper id="impact-card-component__components-impacts-cards-ver__carouselwrapper__l94">
          <ImageCarousel isStep images={props.mainMedia} />
        </CarouselWrapper>
      ) : null}
      <BottomWrapper id="impact-card-component__components-impacts-cards-ver__bottomwrapper__l98">
        <LikesCounter count={props.likes} userLiked={props.liked} impactId={props.impactId} />
        {isTablet && props.showUnSdg && (
          <Box id="impact-card-component__components-impacts-cards-ver__box__l101" mx={'12px'}>
            <UnSdgList unSdg={props.unSdg} />
          </Box>
        )}
        {props.description && props.description !== '<p><br></p>' ? (
          <QuillHtmlParser html={props.description} sx={{ margin: '10px 12px' }} />
        ) : null}
        {props.media.length >= 1 && (
          <Divider
            id="impact-card-component__components-impacts-cards-ver__divider__l108"
            sx={{ borderColor: 'rgba(0,0,0,0.08);' }}
          />
        )}
        {props.media.length >= 1 ? <MediaList media={props.media} /> : null}

        {props.showBcInfo &&
          props.showLatestBcOnImpacts &&
          props.scans &&
          props.scans.length > 0 && (
            <>
              <Divider sx={{ borderColor: 'rgba(0,0,0,0.08);' }} />
              <Box sx={{ px: '12px' }}>
                <LatestBlockchainTransactions
                  scans={props.scans}
                  primaryColor={props.primaryColor}
                  walletAddress={props.walletAddress}
                  showWalletAddress={props.showWalletAddress}
                  accountImage={props.accountImage}
                  scanImage={props.image}
                  scanName={props.subtitle}
                />
              </Box>
            </>
          )}

        {/* <ShareWrapper>
            <TwitterShare title={props.subtitle} />
           </ShareWrapper> */}
        {props.showBcInfo && props.scans && props.scans.length > 0 && (
          <BlockchainVerifiedBanner
            size={40}
            scans={props.scans}
            stroke={props.primaryColor}
            walletAddress={props.walletAddress}
            showWalletAddress={props.showWalletAddress}
            impactImage={props.image}
            impactName={props.subtitle}
            accountImage={props.accountImage}
          />
        )}

        {props.aiGenerated && props.aiVerifiedCount > 0 && props.aiVerifiedInfo && (
          <AIVerifiedBanner aiVerifiedCount={props.aiVerifiedCount} data={props.aiVerifiedInfo} />
        )}
      </BottomWrapper>
    </Item>
  )
}
